import { render, staticRenderFns } from "./IframeRelay.vue?vue&type=template&id=b96ee51a&scoped=true&"
import script from "./IframeRelay.vue?vue&type=script&lang=js&"
export * from "./IframeRelay.vue?vue&type=script&lang=js&"
import style0 from "./IframeRelay.vue?vue&type=style&index=0&id=b96ee51a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96ee51a",
  null
  
)

export default component.exports